import { Collapse, Divider, Image } from 'antd';
import ca from '../../assets/about-icons/in500_3_11zon.png';
import { baseURL, marketsData } from '../../services/api';
import { useEffect, useState } from 'react';

const Indexx500Market = () => {
  const { Panel } = Collapse;
  const [data, setData] = useState() as any;
  useEffect(() => {
    marketsData().then((res) => {
      let requiredData = res.data.find(
        (x: { Symbol: string }) => x.Symbol === 'IN500'
      );
      setData(requiredData);
    });
  }, []);
  return (
    <div
      className="d-flex justify-content-center"
      style={{ marginBottom: 200 }}
    >
      <div className="coll">
        <Collapse
          ghost={true}
          accordion
          style={{
            textAlign: 'center',
            justifyContent: 'center',
            alignContent: 'center',
            color: 'var(--body_color)',
          }}
          defaultActiveKey={2}
        >
          <Panel
            showArrow={false}
            style={{
              backgroundColor: 'var(--body_background)',
              fontSize: 30,
              color: '',
            }}
            header="Market"
            key="1"
          >
            <Divider style={{ marginTop: -20 }}></Divider>
            <p style={{ fontSize: 10 }}>
              <div className="row">
                <div className="col" style={{ textAlign: 'left' }}>
                  <p
                    style={{
                      fontSize: 10,
                      color: 'var(--body_color)',
                      opacity: '60%',
                    }}
                  >
                    Market Cap
                  </p>
                  <p style={{ fontSize: 10, color: 'var(--body_color)' }}>
                    {data?.MarketCap}
                  </p>{' '}
                  <br />
                  <br />
                  <p
                    style={{
                      fontSize: 10,
                      color: 'var(--body_color)',
                      opacity: '60%',
                    }}
                  >
                    POPULARITY
                  </p>
                  <p style={{ fontSize: 10, color: 'var(--body_color)' }}>
                    Not enough data
                  </p>
                  <br />
                  <br />
                  <p
                    style={{
                      fontSize: 10,
                      color: 'var(--body_color)',
                      opacity: '60%',
                    }}
                  >
                    PRICE CHANGE (7D)
                  </p>
                  <p style={{ fontSize: 10, color: 'red' }}>0%</p>
                  <br />
                </div>
                <div className="col" style={{ textAlign: 'left' }}>
                  <p
                    style={{
                      fontSize: 10,
                      color: 'var(--body_color)',
                      opacity: '60%',
                    }}
                  >
                    VOLUME (24H)
                  </p>
                  <p style={{ fontSize: 10, color: 'var(--body_color)' }}>
                    {Math.floor(data?.Volume * 100) / 100}
                  </p>
                  <br />

                  <br />
                  <p
                    style={{
                      fontSize: 10,
                      color: 'var(--body_color)',
                      opacity: '60%',
                    }}
                  >
                    ALL TIME HIGH
                  </p>
                  <p style={{ fontSize: 10, color: 'var(--body_color)' }}>
                    $0.15
                  </p>
                  <br />
                </div>
                <div className="col" style={{ textAlign: 'left' }}>
                  <p
                    style={{
                      fontSize: 10,
                      color: 'var(--body_color)',
                      opacity: '60%',
                    }}
                  >
                    CIRCULATING SUPPLY
                  </p>
                  <p style={{ fontSize: 10, color: 'var(--body_color)' }}>
                    {data?.CirculatingSupply} IN500
                  </p>
                  <br />

                  <br />
                  <p
                    style={{
                      fontSize: 10,
                      color: 'var(--body_color)',
                      opacity: '60%',
                    }}
                  >
                    PRICE CHANGE (1H)
                  </p>
                  <p style={{ fontSize: 10, color: 'red' }}>0%</p>
                  <br />
                </div>
                <div className="col" style={{ textAlign: 'left' }}>
                  <p
                    style={{
                      fontSize: 10,
                      color: 'var(--body_color)',
                      opacity: '60%',
                    }}
                  >
                    TYPICAL HOLD TIME
                  </p>
                  <p style={{ fontSize: 10, color: 'var(--body_color)' }}>
                    1 Year
                  </p>
                  <br />

                  <br />
                  <p
                    style={{
                      fontSize: 10,
                      color: 'var(--body_color)',
                      opacity: '60%',
                    }}
                  >
                    PRICE CHANGE (24H)
                  </p>
                  <p style={{ fontSize: 10, color: 'red' }}>0%</p>
                  <br />
                </div>
              </div>
            </p>
          </Panel>
          <Divider></Divider>
          <Panel
            showArrow={false}
            style={{
              backgroundColor: 'var(--body_background)',
              fontSize: 30,
              color: 'var(--body_color)',
            }}
            header="About Indexx 500"
            key="2"
          >
            <Divider style={{ marginTop: -20 }}></Divider>
            <div style={{ textAlign: 'left', color: 'var(--body_color)' }}>
              <Image
                preview={false}
                style={{ marginBottom: 10, width: 82, height: 82 }}
                src={ca}
              ></Image>
              <br />
              <p style={{ fontSize: 20 }}>Indexx 500 </p>
              <p style={{ fontSize: 15, lineHeight: 2 }}>
                Indexx500 Low Risk, Secure and Simple Indexx500 stock tokens are
                the world first secured coins pegged with world largest stock
                market index S&P 500, having pioneered the concept in the
                digital token space. Most popular token, already sold over $1M
                worth of Indexx500
              </p>
              <br />

              <p style={{ fontSize: 20 }}>How It Works </p>
              <p style={{ fontSize: 15, lineHeight: 2 }}>
                Indexx 500 stock tokens are assets that move across the
                blockchain just as easily as other digital currencies but that
                are pegged to S&P 500 index on a 1-to-1,000 basis. Indexx 500
                stock tokens are referred to as reliable coins because they
                offer price reliable as they are pegged to a S&P 500 index of US
                stock market, This offers traders, merchants and funds a low
                volatility solution when exiting positions in the market. All
                Indexx 500 stock tokens are pegged at 1-to-1,000 with a matching
                S&P 500 (e.g., 1 INXS = 1,000 Share of S&P 500 Index) and are
                backed 100% by Indexx’s reserves.
              </p>
              <div className="font_15x d-flex justify-content-center">
                <a
                  href={`${baseURL}/indexx-exchange/token-details/in500`}
                  className="text_link"
                >
                  Learn More
                </a>
              </div>
            </div>
          </Panel>
        </Collapse>
      </div>
    </div>
  );
};

export default Indexx500Market;
